import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import LoadingBackdrop from "../loadingBackdrop/LoadingBackdrop";
import OrderRecipientInfo from "./OrderRecipientInfo";
import OrderPaymentInfo from "./OrderPaymentInfo";
import OrderAdditionalPlacesInfo from "./OrderAdditionalPlacesInfo";
import OrderDepartureInfo from "./OrderDepartureInfo";
import OrderSenderInfo from "./OrderSenderInfo";
import { OrderAdditionalServices } from "./OrderAdditionalServices";
import { useFreshchatContext } from "../../providers/FreshchatProvider/FreshchatProvider";

function OrderDetails() {
  const { order, loading } = useOutletContext();
  const { updateTrackingCodeField, resetTrackingCodeField } = useFreshchatContext();

  useEffect(() => {
    if (order.trackingCode) {
      updateTrackingCodeField(order.trackingCode);
    }
    return () => {
      resetTrackingCodeField();
    };
  }, [order, resetTrackingCodeField, updateTrackingCodeField]);

  return (
    <>
      <LoadingBackdrop isVisible={loading} />
      <Box className={"shadow-lg pb-2"}>
        <OrderRecipientInfo />
        <Divider orientation={"horizontal"} flexItem className={"smMax:mx-5 smMax:my-2"} />
        <OrderPaymentInfo />
        <Divider orientation={"horizontal"} flexItem className={"smMax:mx-5 smMax:my-2"} />
        {Boolean(order.services?.length) && (
          <>
            <OrderAdditionalServices />
            <Divider orientation={"horizontal"} flexItem className={"smMax:mx-5 smMax:my-2"} />
          </>
        )}
        {order.withPlaces && (
          <>
            <OrderAdditionalPlacesInfo />
            <Divider orientation={"horizontal"} flexItem className={"smMax:mx-5 smMax:my-2"} />
          </>
        )}
        <OrderDepartureInfo />
        <Divider orientation={"horizontal"} flexItem className={"smMax:mx-5 smMax:my-2"} />
        <OrderSenderInfo />
      </Box>
    </>
  );
}

export default OrderDetails;
